import { UTSLocale } from "@smile2impress/attraction-constants";
import { ClinicWithCityTitleProps } from "api/location";

type ForbiddenList<T> = {
    map: T[];
    list: T[];
};

export type ForbidenClinicsIds = ForbiddenList<number>;

export type ForbidenClinicsByLocale = { [K in UTSLocale]?: ForbidenClinicsIds };

const forbiddenToBookClinicsByLocale: ForbidenClinicsByLocale = {
    // Source: https://impress-global.atlassian.net/browse/AD-1356
    [UTSLocale.ITALY_IT]: {
        map: [
            361, 362, 363, 364, 356, 357, 358, 408, 410, 412, 439, 415, 416,
            441, 487, 334,
        ],
        list: [356, 357, 361, 362, 358],
    },
};

export default (
    clinics: ClinicWithCityTitleProps[] = [],
    locale: UTSLocale = UTSLocale.SPAIN_ES,
    filterType: "map" | "list" | "mapAndList" = "map"
): ClinicWithCityTitleProps[] => {
    if (
        clinics.length > 0 &&
        Object.keys(forbiddenToBookClinicsByLocale).includes(locale)
    ) {
        switch (filterType) {
            case "list":
                return clinics.filter(
                    (cl) =>
                        !forbiddenToBookClinicsByLocale[locale]?.list.includes(
                            cl.id
                        )
                );
            case "mapAndList":
                return clinics.filter(
                    (cl) =>
                        !forbiddenToBookClinicsByLocale[locale]?.list.includes(
                            cl.id
                        ) &&
                        !forbiddenToBookClinicsByLocale[locale]?.map.includes(
                            cl.id
                        )
                );
            default:
                return clinics.filter(
                    (cl) =>
                        !forbiddenToBookClinicsByLocale[locale]?.map.includes(
                            cl.id
                        )
                );
        }
    }
    return clinics;
};
